import { createUseStyles } from 'react-jss';
import { mediaQuery } from '@quicktools/shared-components/styles';
import { MENU_COLLAPSE_BREAKPOINT } from '@quicktools/shared-components/components/common/SingleToolNavigation';
import { Spacings } from '@picsart/ds-foundation/spacings';

export default createUseStyles(
  {
    root: {
      display: 'none',
      gap: 4,
      marginTop: -4,
      marginBottom: 8,
      overflowX: 'auto',
      scrollbarWidth: 'none',

      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
        display: 'none',
      },

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        display: 'flex',
      },
    },
    entry: {
      alignItems: 'center',
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 72,
      border: '1px solid var(--x-border-4)',
      color: 'var(--x-text-color-1)',
      display: 'flex',
      fontSize: 14,
      fontWeight: 600,
      gap: 8,
      lineHeight: '20px',
      padding: [6, 12],
      outline: 'none',
      textDecoration: 'none',

      '&:first-child': {
        marginLeft: 16,
      },
    },
    entrySelected: {
      color: 'var(--x-accent-1-1)',
      backgroundColor: '#F6E8F1',
      border: '1px solid var(--x-accent-1-1)',

      '&>svg': {
        fill: 'var(--x-accent-1-1)',
      },
    },
    icon: {
      fill: 'var(--x-text-color-1)',
      height: 20,
      width: 20,
    },
    link: {
      display: 'flex',
      gap: 8,
    },
    text: {
      width: 'max-content',
    },
    button: {
      marginLeft: Spacings.s16,
    },
  },
  { name: 'MobileCategories' },
);
